import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useSWRConfig } from "swr";
import { useLocation } from "wouter";
import { Alert, AlertActions, AlertBody, AlertTitle } from "catalyst/alert";
import { Button } from "catalyst/button";
import { apiAcceptPendingHubInvite, hasPendingInviteCookie, urlApiProfile, } from "./api.js";
import { useActiveHub } from "./activeHub.js";
import { getJson } from "./util.js";
let pendingInviteJoinPromise = null;
export const PendingInviteJoinAlert = () => {
    const { mutate } = useSWRConfig();
    const { setActiveHubId, setPendingInvite } = useActiveHub();
    const [, navigate] = useLocation();
    const [error, setError] = useState(null);
    useEffect(() => {
        const hasPendingInvite = hasPendingInviteCookie();
        if (!hasPendingInvite && pendingInviteJoinPromise === null) {
            return;
        }
        const joinPromise = pendingInviteJoinPromise ??
            (hasPendingInvite ? apiAcceptPendingHubInvite() : null);
        if (joinPromise === null)
            return;
        pendingInviteJoinPromise = joinPromise;
        setPendingInvite(true);
        let cancelled = false;
        void (async () => {
            try {
                const result = await joinPromise;
                if (cancelled)
                    return;
                // Keep the previous hub hidden until its replacement is in the profile.
                setActiveHubId(result.data.hub_id);
                await mutate(urlApiProfile, async () => {
                    const profile = await getJson(urlApiProfile);
                    if (!profile.hubs.some((hub) => hub.hub_id === result.data.hub_id)) {
                        throw new Error("Не удалось загрузить приглашенный хаб. Обновите страницу и попробуйте еще раз.");
                    }
                    return profile;
                }, { revalidate: false });
                if (cancelled)
                    return;
                navigate("/", { replace: true });
            }
            catch (err) {
                if (cancelled)
                    return;
                setError(err instanceof Error ? err.message : String(err));
            }
            finally {
                if (!cancelled) {
                    pendingInviteJoinPromise = null;
                    setPendingInvite(false);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [mutate, navigate, setActiveHubId, setPendingInvite]);
    return (_jsxs(Alert, { open: error !== null, onClose: (open) => {
            if (!open)
                setError(null);
        }, children: [_jsx(AlertTitle, { children: "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435" }), _jsx(AlertBody, { className: "mt-2 text-center text-pretty text-zinc-500 sm:text-left sm:text-sm/6", children: error }), _jsx(AlertActions, { children: _jsx(Button, { onClick: () => setError(null), children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E" }) })] }));
};
